export function SubmitFormPlugin() {
  const tomSelect = this

  tomSelect.hook("after", "setup", () => {
    tomSelect.focus_node.addEventListener("keydown", submitForm)
  })

  function submitForm(event) {
    if (event.key === "Enter") {
      event.preventDefault()

      const form = event.target.closest('form')

      if (!form) {
        return
      }

      const submitButton = form.querySelector("[type=submit]")
      if (submitButton) {
        form.requestSubmit(submitButton)
        return
      }

      const associatedSubmitButton = document.querySelector(`button[form="${form.id}"]`)
      if (associatedSubmitButton) {
        form.requestSubmit(associatedSubmitButton)
      }
    }
  }
}
